"use client";
import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineDocumentText } from "react-icons/hi";

export default function Home({ togglePlay, playing }) {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => setInit(true));
  }, []);

  const options = useMemo(
    () => ({
      background: { color: "transparent" },
      particles: {
        number: { value: 60 },
        color: { value: "#ffffff" },
        links: {
          enable: true,
          color: "#ffffff",
          distance: 160,
          opacity: 0.12,
          width: 1,
        },
        move: { enable: true, speed: 0.6 },
        size: { value: { min: 1, max: 2 } },
        opacity: { value: { min: 0.15, max: 0.45 } },
      },
      interactivity: {
        events: {
          onHover: { enable: true, mode: "repulse" },
          onClick: { enable: true, mode: "push" },
        },
        modes: {
          repulse: { distance: 120 },
          push: { quantity: 2 },
        },
      },
      detectRetina: true,
      responsive: [
        {
          maxWidth: 768,
          options: {
            particles: {
              number: { value: 25 },
              links: { distance: 100, opacity: 0.08 },
            },
          },
        },
      ],
    }),
    []
  );

  const ParticlesBackground = useMemo(() => {
    return init ? <Particles id="tsparticles" options={options} /> : null;
  }, [init, options]);

  return (
    <div className="hero-container">
      {ParticlesBackground}
      <section className="hero">
        <h1 className="hero-title">Brady Li</h1>
        <p className="hero-subtitle">Software Engineer — Researcher — Explorer</p>
        <p className="hero-subtext">I build realities and explore the minds within</p>
        <p className="hero-subtext">Currently: Student :D</p>

        <div className="music-player">
          <p>Music ◈</p>
          <button type="button" onClick={togglePlay} className="music-btn">
            {playing ? "Pause" : "Play"}
          </button>
        </div>

        <div className="connect-buttons">
          <a href="https://github.com/bradylii" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://www.linkedin.com/in/brady-li" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a
            href="/Brady_Li_CV.pdf"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Resume"
          >
            <HiOutlineDocumentText />
          </a>
        </div>
      </section>
    </div>
  );
}
